export const PATH = {
  HOME: "/",
  ABOUT: "/about",
  PROJECT: "/project",
  DASHBOARD: "/dashboard",
  NODECONTROL: "/node-control",
  SIGNUP: "/signup",
  SIGNIN: "/signin",
  FORGOTPASSWORD: "/forgot-password",
  ERRORPAGE: "/error-page",
  ACCOUNTDETAIL: "/account-detail",
  CHANGEPASSWORD: "/change-password",
  CHANGEINFOMATION: "/change-infomation",
  CONTACT: "/contact",
};
